import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/store";

// ===== MODULE IMPORTS =====
import AuthModule from "./modules/auth";
import SnackbarModule from "./modules/snackbar";
import UserModule from "./modules/user";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
Vue.axios.defaults.headers.common["Accept"] = "application/json";
Vue.axios.defaults.headers.common["Content-Type"] = "application/json";
Vue.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.axios.interceptors.response.use(undefined, err => {
    if (err.response.status === 401) {
        store.dispatch("logout");
    }

    return Promise.reject(err);
});

if (sessionStorage.getItem("access_token")) {
    Vue.axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("access_token");
}

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        snackbar: SnackbarModule,
        user: UserModule,
    },
});